export default ({keys, server}) => `package com.stripe.example;

import org.jetbrains.annotations.NotNull;

// A one-field data class used to handle the payment intent response from our backend
public class ServerPaymentIntent {
    @NotNull private final String secret;

    public ServerPaymentIntent(@NotNull String secret) {
        this.secret = secret;
    }

    @NotNull
    public String getSecret() {
        return secret;
    }
}
`;
